const config = require('../../../../../config/locales_json/packs/private/validations/login.json');
const language = $('body').data("language");

/**************************************************
 * 
 *    V A L I D A C I O N E S    U S U A R I O
 * 
*/
$("#kt_login_signin_form #kt_login_signin_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_signin_form #user_email")
  var password = $("#kt_login_signin_form #user_password")

  if(!email.val()){
    const errorText = getTranslationValue(config, [language, "user_email"],"Debes ingresar tu email");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.removeClass("is-invalid")
  }

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "user_password"],"Debes ingresar tu contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    password.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Ingresando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_signin_form").submit()
  }
});

/**************************************************
 * 
 *  V A L I D A C I O N E S    R E C L U T A D O R
 * 
*/
$("#kt_login_recruiter_signin_form #kt_login_recruiter_signin_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_recruiter_signin_form #recruiter_email")
  var password = $("#kt_login_recruiter_signin_form #recruiter_password")
  
  if(!email.val()){
    const errorText = getTranslationValue(config, [language, "recruiter_email"],"Debe ingresar su email");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.removeClass("is-invalid")
  }

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "recruiter_password"],"Debe ingresar su contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    password.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Ingresando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_recruiter_signin_form").submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}
